<template>
    <div class="state-container">
      <template v-if="!finished">
        <div class="circle" v-bind:class="getStatusClass"></div>
        <div class="loading-indicator">{{ getStatusText}}</div>
      </template>
      <template v-else>
        <i class="fas fa-check-circle finished-icon"></i>
        <div class="loading-indicator">{{ $t('shopfloor.unloadingPage.cargoFinishedStatus')}}</div>
      </template>
    </div>
</template>


<script>
    export default {
        name: 'overview-status-indicator',
        props: ['status', 'finished'],
        computed: {
            getStatusText() {
                if (this.status) {
                    return this.$t('shopfloor.status.' + this.status)
                } else {
                    return this.$t('shopfloor.status.waiting')
                }
            },
            getStatusClass() {
                let status = this.status
                switch (true) {
                    case status === 'loading':
                        return 'status-loading-busy';
                        break;
                    case status == 'waiting':
                        return 'status-loading-idle';
                        break;
                    case status === 'done':
                        return 'status-loading-done';
                        break;
                    default:
                        return 'status-loading-idle';
                        break;
                }
            }
        }

    }
</script>


<style lang="scss" scoped>

    .state-container {
        display: grid;
        grid-template-columns: 2rem auto;;
        grid-template-rows: auto;
        grid-column-gap: 1rem;
        grid-row-gap: 0px;
    }

    .loading-indicator {
        color: #888888;
        font-size: 16px;
        align-self: center;
    }

    .status-loading-idle {
        background-color: #ffa0a0;
    }

    .status-loading-busy {
        background-color: #ffaf46;
    }

    .status-loading-done {
        background-color: #00b954;
    }

    .finished-icon {
      color: #00b954;
      font-size: 2rem;
    }

    .circle {
        width: 2rem;
        height: 2rem;
        border: 1px solid white;
        -moz-border-radius: 50px;
        -webkit-border-radius: 50px;
        border-radius: 50px;
    }

</style>

